import api from './api';

const smsNotificationService = {
    sendOTP: (data) => api.post('/sms-notification/send-otp', data),
    verifyOTP: (data) => api.post('/sms-notification/verify-otp', data),
    getDashboardStats: () => api.get('/sms-notification/dashboard-stats'),
    getOtpLogs: (params) => api.get('/sms-notification/logs', { params }),
};

export default smsNotificationService;
